import {
  POST_PHONE_SUCCESS,
  POST_PHONE_FAILURE,
  VERIFY_PHONE_SUCCESS,
  VERIFY_PHONE_FAILURE
} from '../../actions/api/phone';

export default function PhoneVerification(state = {}, action) {
  switch (action.type) {
    case POST_PHONE_SUCCESS:
      return {
        ...state,
        addCode: true,
        addPhone: false,
        phoneAddSuccess: false,
        deletePhoneSuccess: false,
        error: {
          addPhone: null,
          addCode: null
        }
      };
    case POST_PHONE_FAILURE:
      return {
        ...state,
        error: {
          addPhone: action.error
        }
      };
    case VERIFY_PHONE_SUCCESS:
      if (!action.response.phone) {
        return {
          ...state,
          error: {
            addCode: true
          }
        };
      }
      return {
        ...state,
        phoneAddSuccess: true,
        addCode: false,
        addPhone: false,
        error: {
          addCode: null
        }
      };
    case VERIFY_PHONE_FAILURE:
      return {
        ...state,
        error: {
          addCode: action.error
        }
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./js/reducers/page/PhoneVerification.js